<template>
  <div>
    <TheHeader></TheHeader>
    <BreadcrumbBar />
    <PageHeader hero>
      <TextHeading variant="subtitle" color="secondary">About Us</TextHeading>
      <TextHeading variant="xl" block>Morrisons Brands</TextHeading>
    </PageHeader>
    <SubMenuMobile />
    <PageGrid sidebar>
      <PageSide>
        <SideNav />
        <KeyUpcomingDates />
      </PageSide>
      <PageMain>
        <CardInformation v-for="item in items" v-bind:data="item" v-bind:key="item.id"></CardInformation>
        <ShareLinksArticle mobile></ShareLinksArticle>
      </PageMain>
    </PageGrid>
    <TheFooter></TheFooter>
  </div>
</template>

<script>
import TheFooter from '../components/TheFooter.vue'
import PageMain from '../elements/PageMain.vue'
import KeyUpcomingDates from '../components/KeyUpcomingDates.vue'
import SideNav from '../components/SideNav.vue'
import PageSide from '../elements/PageSide.vue'
import PageGrid from '../elements/PageGrid.vue'
import SubMenuMobile from '../components/SubMenuMobile.vue'
import TextHeading from '../elements/TextHeading.vue'
import PageHeader from '../components/PageHeader.vue'
import BreadcrumbBar from '../components/BreadcrumbBar.vue'
import TheHeader from '../components/TheHeader.vue'
import CardInformation from '../components/CardInformation.vue'
export default {
  name: 'MorrisonsBrands',
  components: {
    TheHeader,
    BreadcrumbBar,
    PageHeader,
    TextHeading,
    SubMenuMobile,
    PageGrid,
    PageSide,
    SideNav,
    KeyUpcomingDates,
    PageMain,
    TheFooter,
    CardInformation
  },
  data() {
    return {
      items: [
        {
          image: require('@/assets/images/logos/logo-blank.png'),
          title: 'Morrisons Savers',
          text:
            'Helping you to eat well, our Morrisons Savers range features everyday products at the lowest possible price, without compromising on quality.'
        },
        {
          image: require('@/assets/images/logos/logo-blank.png'),
          title: 'Wonky',
          text:
            'Helping to tackle food waste, our Wonky range features naturally scarred or misshapen fruit and veg that’s still perfectly good to eat, meaning we buy the whole crop from our farmers.',
          button: 'Find Out More'
        },
        {
          image: require('@/assets/images/logos/logo-blank.png'),
          title: 'Market Street',
          text:
            'Our Market Street range features good quality fresh food and flowers, providing our customers with great value to help them enjoy living and eating well.',
          pic: require('@/assets/images/morrisons-4-3-ratio.jpg')
        },
        {
          image: require('@/assets/images/logos/logo-blank.png'),
          title: 'Morrisons Makes It',
          text:
            'Our Morrisons Makes It range features great quality products that have been either prepared or finished by our expert food makers.'
        },
        {
          image: require('@/assets/images/logos/logo-blank.png'),
          title: 'The Best',
          text:
            'Our Morrisons The Best range features expertly sourced and created products, bringing our customers the best quality ideal for special occasions and treats.'
        },
        {
          image: require('@/assets/images/logos/logo-blank.png'),
          title: 'Organic',
          text:
            'The Morrisons Organic range is full of naturally sourced products that are affordable, sustainably packaged and good quality you can trust'
        },
        {
          image: require('@/assets/images/logos/logo-blank.png'),
          title: 'Free From',
          text:
            'Our Free From range features a huge variety of products to help you enjoy a ‘free from’ lifestyle. The range provides allergen-free options at great value for customers.'
        },
        {
          image: require('@/assets/images/logos/logo-blank.png'),
          title: 'V Taste',
          text:
            'A delicious range of plant-based meals, V Taste products aim to inspire all customers, regardless of their dietary lifestyle choices.'
        },
        {
          image: require('@/assets/images/logos/logo-blank.png'),
          title: 'Counted',
          text:
            'Full of delicious ideas and inspiration, the Morrisons Fresh Ideas range features nutritious and exciting meals and meal components to help customers enjoy eating well. You’ll also find on the go options in this range.'
        },
        {
          image: require('@/assets/images/logos/logo-blank.png'),
          title: 'Fresh Ideas',
          text:
            'Full of delicious ideas and inspiration, the Morrisons Fresh Ideas range features nutritious and exciting meals and meal components to help customers enjoy eating well. You’ll also find on the go options in this range.'
        },
        {
          image: require('@/assets/images/logos/logo-blank.png'),
          title: 'Little Kitchen',
          text:
            'Developed especially for children, the Morrisons Little Kitchen range has been created to strict nutritional standards (and taste approved by kids!). The range includes both food and drink, and gives back to CLIC Sargent through an annual donation.'
        },
        {
          image: require('@/assets/images/logos/logo-blank.png'),
          title: 'Nutmeg',
          text: 'Nutmeg information to come...',
          button: 'Find Out More',
          pic: require('@/assets/images/morrisons-4-3-ratio.jpg')
        }
      ]
    }
  }
}
</script>
